var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.previewName,staticClass:"preview",class:{ show: _vm.previewVisible },attrs:{"id":_vm.previewName,"tabindex":"-1"},on:{"focusout":function($event){_vm.removeTransformers(true), _vm.exportMainImageToStore()}}})}
var staticRenderFns = []

export { render, staticRenderFns }